<template>
  <common-template>
    <div class="sticky-button" @click="createModalOpen">
      <i class="fas fa-plus-circle"></i>
    </div>
      <div class="list">
        <h1 class="title d-flex inner"></h1>
        <div class="q-pa-md">
          <div class="q-gutter-y-md">
            <q-card>
              <h1 class="title inner py-3">
                <svg class="file-icon mr-1" viewBox="0 0 24 24">
                  <use xlink:href="#file-22" />
                </svg>
                {{ $t(pageTitle) }}
              </h1>
              <q-tabs
                v-model="currentTab"
                dense
                class="bg-grey-3 q-tabs-header"
                indicator-color="primary"
                align="justify"
              >
                <template v-for="(item, index) in businessFormTypes">
                  <q-tab :key="index" :name="item.id" :label="item.name"></q-tab>
                </template>
              </q-tabs>

              <q-separator></q-separator>

              <q-tab-panels v-model="currentTab" @before-transition="onChangeTab" animated>
                <template v-for="(item, index) in businessFormTypes">
                  <q-tab-panel :key="index" :name="item.id">
                    <business-form-list
                      :businessForms="businessForms"
                      :businessFormType="selectedBusinessFormType.type"
                      :partners="partners"
                      :load="load"
                      :company="company"
                      @emit-registed="init"
                    />
                  </q-tab-panel>
                </template>
              </q-tab-panels>
            </q-card>
          </div>
        </div>
      </div>
    <svgs />
    <create-business-form-modal
      ref="createBusinessFormModal"
      @registed="init"
    ></create-business-form-modal>
  </common-template>
</template>

<script>
import svgs from './svgs'
import { mapGetters } from 'vuex'
import Api from '../../mixin/api'
import businessFormList from './businessFormList'
import createBusinessFormModal from './createBusinessFormModal'
import pref from '../../assets/json/pref.json'

const estimate_print = { id: 'estimate_print', name: '見積書', type: 'estimate' }
const businessFormTypes = [
  estimate_print,
  { id: 'receipt_print', name: '注文請書', type: 'receipt' },
  { id: 'estimate_request_print', name: '見積依頼書', type: 'estimateRequest' },
  { id: 'purchase_print', name: '発注書', type: 'purchase' },
  { id: 'slip_print', name: '検収現品票', type: 'slip' },
  { id: 'purchase_slip_print', name: '発注書＋現品票', type: 'purchaseSlip' },
  { id: 'shipment_print', name: '納品書', type: 'shipment' },
  { id: 'receipt_unit_print', name: '受領書', type: 'receiptUnit' },
  { id: 'shipment_slip_print', name: '出荷現品票', type: 'shipmentSlip' },
  { id: 'shipment_receipt_print', name: '納品書＋受領書', type: 'shipmentReceipt' },
  { id: 'bill_print', name: '請求書', type: 'bill' },
]

export default {
  mixins: [Api],
  data() {
    return {
      businessForms: [],
      load: false,
      master: {},
      company: {},
      businessForm: {},
      pref: pref,
      partners: [],
      pageTitle: '帳票カスタマイズ設定',
      currentTab: 'estimate_print',
      selectedBusinessFormType: estimate_print,
      businessFormTypes: businessFormTypes,
    }
  },
  components: {
    svgs,
    businessFormList,
    createBusinessFormModal,
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    this.load = true

    // masterから一括でデータを取得
    const masterData = await this.$axios.get(
      `${this.$appConfig.CommonApiUrl}/masters`,
      {
        headers: {
          Authorization: this.authorization ? this.authorization : null,
        },
      }
    )
    if (masterData) this.master = masterData.data

    if (this.master.partners) {
      this.partners = this.master.partners.filter(partner => partner.isCustomer)
    }

    this.company = this.master.company
    if (this.master.company.logoImage) {
      const params = {}
      params.targets = [this.master.company.logoImage]
      const s3 = await this.$axios({
        method: 'post',
        headers: {
          Authorization: this.authorization ? this.authorization : null,
        },
        url: `${this.$appConfig.CommonApiUrl}/s3/urls`,
        data: params,
      })
      this.company.logoImageURL = s3.data[this.master.company.logoImage]
    }
    if (this.master.company.signImage) {
      const params = {}
      params.targets = [this.master.company.signImage]
      const s3 = await this.$axios({
        method: 'post',
        headers: {
          Authorization: this.authorization ? this.authorization : null,
        },
        url: `${this.$appConfig.CommonApiUrl}/s3/urls`,
        data: params,
      })
      this.company.signImageURL = s3.data[this.master.company.signImage]
    }
    this.company.prefName = this.getPrefName(this.company)
    try {
      await this.$store.dispatch('auth/user')
    } catch (err) {
      this.$toasted.show(err)
      this.$toasted.show('Userの取得でエラー')
    }
    await this.getBusinessForms()
  },
  methods: {
    async init() {
      this.load = true
      this.businessForms = []
      await this.getBusinessForms()
    },
    async getBusinessForms() {
      try {
        this.load = true
        const params = {}
        this.businessForms = await this.mixinGetAPI(`${this.$appConfig.CommonApiUrl}/business_forms`, params)
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
      this.load = false
    },
    onChangeTab(newValue) {
      const type = businessFormTypes.find(item => item.id === newValue) || {}
      this.selectedBusinessFormType = type
    },
    createModalOpen() {
      const item = this.selectedBusinessFormType
      item.companyId = this.company.id
      this.$refs.createBusinessFormModal.createModalOpen(item)
    },
    getPrefName(item) {
      const prefs = this.pref[item.countryCode] || []
      const pref = prefs.find(value => value.code == item.prefCode) || {}
      return pref.name || ''
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .vue-simple-suggest.designed .input-wrapper input {
    padding:.375rem .75rem !important;
  }
  .q-field__native, .q-field__prefix, .q-field__suffix, .q-field__input {
    padding-left: 20px !important;
  }
  .q-btn__content.col, .row {
    margin: 0 !important;
  }
  .sticky-button {
    position: fixed;
    bottom: 0;
    margin-bottom: 20px !important;
    z-index: 998;
    right: 50px;
  }
  .fa-plus-circle {
    font-size: 40px;
    color: #28A745;
    background-color: white;
    border-radius: 50%;
    cursor: pointer;
  }
  .file-icon {
    width: 21px;
    height: 30px;
  }
  .note-31 {
    width: 21px;
    height: 21px;
    fill: white !important;
  }
  .icon {
    width: 21px;
    height: 21px;
  }
  .no-border {
    border: none !important;
  }
  td {
    word-break: break-all;
  }
}
</style>
